const authManager = {

  setTowerHeadAdminAccessToken: (accessToken) => {
    try {
      localStorage.setItem("accessTowerHeadAdminToken", accessToken);
    } catch (error) {
      console.error("Error setting access token:", error);
    }
  },

  getTowerHeadAdminAccessToken: () => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("accessTowerHeadAdminToken");
  },

  deleteTowerHeadAdminAccessToken: () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("accessTowerHeadAdminToken");
    }
  },

  hasTowerHeadAdminAccessToken: () => {
    if (typeof window === "undefined") return false;
    return !!localStorage.getItem("accessTowerHeadAdminToken");
  },
};

export default authManager;
